import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14f89f71"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mt-0 mb-0" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "nav nav-pills flex-column" }
const _hoisted_4 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nav-link text-center" }, "暂无数据", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "nav-link" }
const _hoisted_8 = { class: "float-right" }

export function render(_ctx, _cache) {
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_vue_draggable_next = _resolveComponent("vue-draggable-next")
  const _component_app_modal = _resolveComponent("app-modal")

  return (_openBlock(), _createBlock(_component_app_modal, {
    ref: "draggableListviewModal",
    title: _ctx.title,
    size: "default",
    submitFunction: _ctx.submitFunction,
    submitAfterClose: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("ul", _hoisted_3, [
            (_ctx.draggableList.length < 1)
              ? (_openBlock(), _createElementBlock("li", _hoisted_4, _hoisted_6))
              : _createCommentVNode("", true),
            _createVNode(_component_vue_draggable_next, {
              list: _ctx.draggableList,
              group: _ctx.group,
              "item-key": "id",
              animation: "500",
              onStart: _cache[0] || (_cache[0] = $event => (_ctx.drag=true)),
              onEnd: _cache[1] || (_cache[1] = $event => (_ctx.drag=false))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draggableList, (element) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: element.name,
                    class: "nav-item"
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_svg_icon, { name: "trail-sign-outline" }),
                      _createTextVNode(" " + _toDisplayString(element.sort) + ". " + _toDisplayString(element.name) + " ", 1),
                      _createElementVNode("span", _hoisted_8, [
                        _createVNode(_component_svg_icon, { name: "swap-vertical-outline" })
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["list", "group"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "submitFunction"]))
}